<template>
    <div></div>
</template>

<script>
export default {
    name: 'LayoutAuth'
}
</script>
